/* eslint no-process-env:0 */
import React                        from 'react';
import {
 Route,
 Switch,
 Redirect
}                                   from 'react-router-dom';
import HomeConnected                from '../views/home';
import RevenueConnected             from '../views/revenue';
import BatchHealthConnected         from '../views/batchhealth';
import CustomersConnected           from '../views/customers';
import LeadsConnected               from '../views/leads';
import SalesConnected               from '../views/sales';
import SessionsConnected            from '../views/sessions';
import CohortConnected              from '../views/cohort';
import CollectionConnected          from '../views/collection';

import AlertConnected               from '../views/alert';
import BasicElementsConnected       from '../views/basicElements';
import BasicProgressBarConnected    from '../views/basicProgressBar';
import BreadcrumbViewConnected      from '../views/breadcrumb';
import EarningGraphConnected        from '../views/earningGraph';
import GeneralConnected             from '../views/general';
import NotificationsConnected       from '../views/notifications';
import PageNotFoundConnected        from '../views/pageNotFound';
import PaginationViewConnected      from '../views/pagination';
import SimpleTablesConnected        from '../views/simpleTables';
import StatViewConnected            from '../views/stat';
import StatsCardConnected           from '../views/statsCard';
import StripedProgressBarConnected  from '../views/stripedProgressBar';
import TabPanelConnected            from '../views/tabPanel';
import TeamMatesViewConnected       from '../views/teamMates';
import TodoListViewConnected        from '../views/todoList';
import TwitterFeedConnected         from '../views/twitterFeed';
import WorkProgressConnected        from '../views/workProgress';

import PartnerDashboardConnected    from '../views/partner/partnerDashboard';
import PartnerBFCConnected    from '../views/partner/partnerBFC';
import PartnerBBFSConnected         from '../views/partner/partnerBBFS';
import PartnerFootballConnected     from '../views/partner/partnerFootball';
import PartnerPlayConnected         from '../views/partner/partnerPlay';
import PartnerRentalConnected       from '../views/partner/partnerRental';
import PartnerBadmintonConnected    from '../views/partner/partnerBadminton';
import PartnerBadmintonAcademyConnected    from '../views/partner/partnerBadmintonAcademy';
import PartnerBadmintonPlayConnected    from '../views/partner/partnerBadmintonPlay';
import PartnerTournamentConnected   from '../views/partner/partnerTournament';
import PartnerSummerConnected       from '../views/partner/partnerSummer';
import PartnerSummerBadmintonConnected       from '../views/partner/partnerSummerBadminton';
import PartnerKidslistConnected       from '../views/partner/partnerKidslist';
import add_credit               from '../views/partner/crud/add_credit';
import CreateFixtureConnected                   from '../views/partner/crud/createFixture';
import CustomerDetailsConnected                        from '../views/partner/crud/customerDetails';
import AbsenteeReasonConnected                        from '../views/partner/crud/absenteeReason';
import EditFixtureConnected                     from '../views/partner/crud/editFixture';
import AddRentalConnected                       from '../views/partner/crud/addRental';
import AddLeadConnected                       from '../views/partner/crud/addlead';
import AddTournamentTeamMemberConnected         from '../views/partner/crud/addTournamentTeamMember';
import AddTournamentConnected                   from '../views/partner/crud/addTournament';
import AddTeamConnected                         from '../views/partner/crud/addTeam';
import ViewTournamentConnected                  from '../views/partner/crud/viewTournament';
import AddSubscriptionConnected                 from '../views/partner/crud/addSubscription';
import AddTournamentTeamConnected               from '../views/partner/crud/addTournamentTeam';
import AddTournamentFixtureConnected            from '../views/partner/crud/addTournamentFixture';
import HostGameConnected                        from '../views/partner/crud/hostGame';
import PartnerNotificationConnected             from '../views/partner/partnerNotification';
import CancelSessionConnected                       from '../views/partner/crud/cancelSession';
import DeleteFixtureConnected                   from '../views/partner/crud/deleteFixture';
import DeleteTournamentConnected                from '../views/partner/crud/deleteTournament';
import DeleteMatchConnected                from '../views/partner/crud/deleteMatch';
import DeleteTeammemberConnected                from '../views/partner/crud/deleteTeammember';
import DeleteTeamConnected                from '../views/partner/crud/deleteTeam';
import EditTournamentConnected                  from '../views/partner/crud/editTournament';
import EditTeamConnected                        from '../views/partner/crud/editTeam';
import EditMatchConnected                       from '../views/partner/crud/editMatch';
import EditStatsConnected                       from '../views/partner/crud/editStats';
import EditLeadConnected                       from '../views/partner/crud/editLead';
import EditProfileConnected                       from '../views/partner/crud/editProfile';
import ChildProfileConnected                       from '../views/partner/crud/childProfile';
import FeedbackStatusConnected                       from '../views/partner/crud/feedbackStatus';
import EditTournamentSubscriptionConnected      from '../views/partner/crud/editTournamentSubscription';
import ScheduleDemoConnected                       from '../views/partner/crud/scheduleDemo';
import requireAuthentication                    from '../services/auth';
import AddEventConnected                        from '../views/partner/crud/addEvent';
import EditEventConnected                       from '../views/partner/crud/editEvent';
import CancelBookingConnected                   from '../views/partner/crud/cancelBooking';
import TournamentPricingConnected                   from '../views/partner/crud/tournamentPricing';

import SessionObjectiveConnected                   from '../views/partner/crud/sessionObjective';

import AddBulkBookingConnected                     from '../views/partner/crud/addBulBooking';
import UpdateCourtBookingConnected              from '../views/partner/crud/updateCourtBooking';
import FoodRentalConnected              from '../views/partner/crud/foodRental';
import PartnerCourtBookingConnected         from '../views/partner/partnerCourtBooking';

import EditTargetConnected                  from '../views/partner/crud/editTarget';


export const MainRoutes = ({superUser, partner}) => (
  <Switch>

    <Route exact path="/" component={PartnerDashboardConnected}/>
    <Route exact path="/dashboard" component={HomeConnected}/>
    <Route exact path="/revenue" component={RevenueConnected} />
    <Route exact path="/collection" component={CollectionConnected} />
    <Route exact path="/sales" component={SalesConnected} />
    <Route exact path="/cohort" component={CohortConnected} />

    <Route exact path="/batchhealth" component={BatchHealthConnected} />
    <Route exact path="/customers" component={CustomersConnected} />
    <Route exact path="/leads" component={LeadsConnected} />
    <Route exact path="/sessions" component={SessionsConnected} />



    <Route path="/Dashboard/statsCard" component={StatsCardConnected} />
    <Route path="/Dashboard/earningGraph" component={EarningGraphConnected} />
    <Route path="/Dashboard/notifications" component={NotificationsConnected} />
    <Route path="/Dashboard/workProgress" component={WorkProgressConnected} />
    <Route path="/Dashboard/twitterFeed" component={TwitterFeedConnected} />
    <Route path="/Dashboard/teamMates" component={TeamMatesViewConnected} />
    <Route path="/Dashboard/todoList" component={TodoListViewConnected} />
    <Route exact path="/simpleTables" component={SimpleTablesConnected} />
    <Route exact path="/basicElements" component={BasicElementsConnected} />
    <Route exact path="/general" component={GeneralConnected} />
    <Route path="/general/breadcrumb" component={BreadcrumbViewConnected} />
    <Route path="/general/stat" component={StatViewConnected} />
    <Route path="/general/basicProgressBars" component={BasicProgressBarConnected} />
    <Route path="/general/tabPanels" component={TabPanelConnected} />
    <Route path="/general/stripedProgressBars" component={StripedProgressBarConnected} />
    <Route path="/general/alerts" component={AlertConnected} />
    <Route path="/general/pagination" component={PaginationViewConnected} />


    <Route exact path="/partnerDashboard" component={PartnerDashboardConnected}/>
    <Route exact path="/partnerAcademy" component={PartnerBBFSConnected}/>
    <Route exact path="/partnerFootball" component={PartnerFootballConnected}/>
    <Route exact path="/PartnerPlay" component={PartnerPlayConnected}/>
    <Route exact path="/partnerRental" component={PartnerRentalConnected}/>
    <Route exact path="/partnerBadminton" component={PartnerBadmintonConnected}/>
    <Route exact path="/partnerBadmintonAcademy" component={PartnerBadmintonAcademyConnected}/>
    <Route exact path="/partnerTournament" component={PartnerTournamentConnected}/>
    <Route exact path="/partnerSummer" component={PartnerSummerConnected}/>
    <Route exact path="/partnerSummerBadminton" component={PartnerSummerBadmintonConnected}/>
    <Route exact path="/partnerBadmintonPlay" component={PartnerBadmintonPlayConnected}/>
    <Route exact path="/partnerBFC" component={PartnerBFCConnected}/>
    <Route exact path="/bfcKidslist" component={PartnerKidslistConnected}/>

    <Route exact path="/crud/createFixture" component={CreateFixtureConnected}/>
    <Route path='/crud/editFixture/:id' component={EditFixtureConnected}/>
    <Route exact path="/crud/addTournamentTeamMember" component={AddTournamentTeamMemberConnected}/>

    <Route exact path="/crud/createFixture" component={CreateFixtureConnected}/>


    <Route exact path="/crud/add_credit" component={add_credit}/>


    <Route  path='/crud/customerDetails/:id/:page?' component={CustomerDetailsConnected}/>
    <Route path='/crud/editFixture/:id' component={EditFixtureConnected}/>
    <Route path='/crud/absenteeReason/:id' component={AbsenteeReasonConnected}/>
    <Route exact path="/crud/addRental" component={AddRentalConnected}/>
    <Route exact path="/crud/addlead" component={AddLeadConnected}/>
    <Route exact path="/crud/addTournamentTeamMember/:tournament_id/:team_id/:team_name" component={AddTournamentTeamMemberConnected}/>
    <Route exact path="/crud/addTournament" component={AddTournamentConnected}/>
    <Route exact path="/crud/addTeam" component={AddTeamConnected}/>
    <Route path='/crud/viewTournament/:id' component={ViewTournamentConnected}/>
    <Route exact path="/crud/addSubscription" component={AddSubscriptionConnected}/>
    <Route path='/crud/addTournamentTeam/:id' component={AddTournamentTeamConnected}/>
    <Route path='/crud/addTournamentFixture/:id' component={AddTournamentFixtureConnected}/>
    <Route exact path="/crud/hostGame" component={HostGameConnected}/>
    <Route exact path="/partnerNotification" component={PartnerNotificationConnected}/>
    <Route path='/crud/cancelSession/:id' component={CancelSessionConnected}/>
    <Route path='/crud/deleteFixture/:id' component={DeleteFixtureConnected}/>
    <Route path='/crud/deleteTournament/:id' component={DeleteTournamentConnected}/>
    <Route path='/crud/deleteMatch/:id' component={DeleteMatchConnected}/>
    <Route path='/crud/deleteTeammember/:id' component={DeleteTeammemberConnected}/>
    <Route path='/crud/deleteTeam/:id/:team' component={DeleteTeamConnected}/>
    <Route path='/crud/editTournament/:id' component={EditTournamentConnected}/>
    <Route path='/crud/editTeam/:id' component={EditTeamConnected}/>
    <Route path='/crud/editLead/:id' component={EditLeadConnected}/>
    <Route path='/crud/childProfile/:id' component={ChildProfileConnected}/>
    <Route path='/crud/editProfile/:id' component={EditProfileConnected}/>
    <Route path='/crud/editMatch/:id' component={EditMatchConnected}/>
    <Route path='/crud/editStats/:id' component={EditStatsConnected}/>
    <Route path='/crud/feedbackStatus/:id/:types' component={FeedbackStatusConnected}/>
    <Route path='/crud/scheduleDemo/:id' component={ScheduleDemoConnected}/>
    <Route path='/crud/editTournamentSubscription/:id/:amount_paid' component={EditTournamentSubscriptionConnected}/>
    <Route path='/crud/addEvent' component={AddEventConnected}/>
    <Route path='/crud/editEvent/:id' component={EditEventConnected}/>
    <Route path='/crud/cancelBooking/:id' component={CancelBookingConnected}/>
    <Route path='/crud/tournamentPricing/:id' component={TournamentPricingConnected}/>

    <Route path='/crud/sessionObjective/:id' component={SessionObjectiveConnected}/>
    <Route exact path='/crud/addBulkBooking' component={AddBulkBookingConnected}/>
    <Route exact path='/crud/updateCourtBooking/:id' component={UpdateCourtBookingConnected}/>
    <Route exact path='/crud/foodRental' component={FoodRentalConnected}/>


    <Route path='/partnercourtbooking' component={PartnerCourtBookingConnected}/>

    <Route path='/crud/editTarget' component={EditTargetConnected}/>



  </Switch>
);

export default MainRoutes;



// WEBPACK FOOTER //
// ./src/app/routes/MainRoutes.js